export default "/images/image.svg?8aa9aa0284685efe1814743b2dcccc07";